/**
 * import Vue
 * ※vueを使用しない場合は削除する
 */
// import App from './vue/App.js';

/**
 * import node_modules
 */
import 'desvg';
import SmoothScroll from 'smooth-scroll';

/**
 * import modules
 */
// import Sample from './modules/sample';
// import Slider from './modules/slider';
import TopParallax from './modules/topParallax';
import Inview from './modules/in_view';
import HoverAdd from './modules/hover_add';
import ClickAdd from './modules/click_add';
import TopWorksSlide from './modules/topWorksSlide';
import TopTab from './modules/topTab';
import BreadcrumbLangCheck from './modules/breadcrumb_lang_check';
import Accordion from './modules/accordion';
import VueAchievementTab from './modules/vue_achievement_tab';
import AchievementSlider from './modules/achievementSlide';
import Recruite_top_movie from './modules/recruite_top_movie';
import RecruitSecondaryHeader from './modules/recruit_secondary_header';
import MovieModal from './modules/movie_modal';
import MangaModal from './modules/manga_modal';
import RecruiteAboutCounter from './modules/recruite_about_counter';
import ContactSelectbox from './modules/contact_selectbox';
// import VueNews from './modules/vue_news';
import historyScroll from './modules/history_scroll';
/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();
  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();
    });
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    // new Sample('hello'); // クラス内の記述の見本
    new VueAchievementTab();
    // new VueNews('js-vueNews--news');
    new HoverAdd();
    new ClickAdd();
    new Accordion();
    new MovieModal();
    new MangaModal();
    new RecruiteAboutCounter();
    new ContactSelectbox;
    new TopTab();
    new BreadcrumbLangCheck();
  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {
    this.init_deSVG('.js-desvg');
    new TopParallax();
    new Inview();
    new TopWorksSlide();
    new AchievementSlider();
    new Recruite_top_movie();
    new RecruitSecondaryHeader();
    new historyScroll();
    this.init_smoothScroll();
  }

  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  init_deSVG(target) {
    deSVG(target, true);
  }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  init_smoothScroll() {
    /**
     * ターゲットとなる要素
     * @type {Element}
     */
    const targetElement = 'a[href*="#"]';

    /**
     * オプション
     * @type {object}
     */
    const option = {
      speed: 1000,
      easing: 'easeInOutCubic',
      speedAsDuration: true,
      header: '.l-header' // 固定ヘッダーの場合
    };

    new SmoothScroll(targetElement, option);
  }

}

export default new Main();
